import { Route } from '@angular/router';
import { ToolsComponent } from './pages/tools/tools.component';
import { MapComponent } from './pages/map/map.component';

export const appRoutes: Route[] = [
  { path: '', component: MapComponent }, // Route for landing page
  { path: 'tools', component: ToolsComponent }, // Route for dev tools page
  { path: '**', redirectTo: '' } // Wildcard route for a 404 page, redirecting to landing
];
